import { Redirect, useLocation, useParams } from 'react-router-dom'

const HighlightRedirect = () => {
  const { highlightId } = useParams()
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const playerId = params.get('playerId')

  if (playerId) {
    return (
      <Redirect
        to={`/player/${playerId}/highlights?highlightId=${highlightId}`}
      />
    )
  }

  return <Redirect to='/home' />
}

export default HighlightRedirect
